import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "preview"]

  async loadPrintWindow(e) {
    e.preventDefault();
    var form = this.formTarget;
    var url = form.action + window.location.search;
    console.log(url);

    const printWindow = window.open(url, "printable", "menubar=no, width=800, height=600")
  };

  printCard(e) {
    e.preventDefault;
    window.print();
  }
}
